import styled from 'styled-components'
import { Layout } from 'antd'

export const CustomLayout = styled(Layout)`
  height: 100vh;

  .logo {
    background: #fff;
    border-radius: 2px;
    height: 32px;
    margin: 16px;

    img {
      height: 100%;
      object-fit: cover;
      width: 100%;
    }
  }

  main {
    overflow: scroll;
    margin: 24px 16px 0;
  }

  .site-layout-sub-header-background {
    align-items: center;
    background: #fff;
    display: flex;
    justify-content: space-between;
    padding: 0 25px;
    width: 100%;
  }

  .site-layout-background {
    background: #fff;
    min-height: 360px;
    padding: 24px;
  }

  .ant-menu-title-content {
    letter-spacing: 0.25px;
  }

  .email-wrap {
    align-items: flex-end;
    display: flex;
    flex-direction: column;
    padding-right: 1em;
    width: 100%;
  }
`;